module.exports = __webpack_public_path__ + "static/15-e44b7d03f752c7d2a5d3f9836fd1e4fb.jpg";